<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    // this.$wx.getOpenId();
  },
};
</script>

<style lang="scss">
html {
  background-color: #e4ecee;
}

::-webkit-scrollbar {
  width: 8px;
  position: absolute;
  background-color: transparent;
  -webkit-border-radius: 100px
}

::-webkit-scrollbar:hover {
  background-color: rgba(0, 0, 0, .09)
}

::-webkit-scrollbar:horizontal {
  height: 0
}

::-webkit-scrollbar-thumb:vertical {
  background: rgba(0, 0, 0, .5);
  -webkit-border-radius: 100px
}

::-webkit-scrollbar-thumb:vertical:active {
  background: rgba(0, 0, 0, .61);
  -webkit-border-radius: 100px
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

* {
  box-sizing: border-box;
}

body {
  padding: 0;
  margin: 0;
}

.el-dialog__wrapper.custom-dialog {
  display: flex;
  align-items: center;
}
</style>
